import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
	getProxyUsages
} from '@/api/proxy-usage'
import IApiResponse from '@/types/api-response'
import IList from '@/types/list-result'
import IPagination from '@/types/pagination'

interface ProxyUsageState {
	proxy_usage: IProxyUsage[]
	loading: boolean
	error: string | null
	pagination?: IPagination
}

export interface IProxyUsage {
	_id: string
	
}

const initialState: ProxyUsageState = {
	loading: false,
	proxy_usage: [],
	error: null,
}

export const fetchProxyUsage = createAsyncThunk<
	IApiResponse<IList<IProxyUsage>>,
	any
>('report/proxy_usage_history_request', async (params: any) => {
	return await getProxyUsages(params)
})

const accountSlice = createSlice({
	name: 'report-proxy-usage',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchProxyUsage.pending, (state) => {
				state.loading = true
				state.error = null
			})
			.addCase(fetchProxyUsage.fulfilled, (state, { payload }) => {
				state.loading = false
				state.pagination = payload.data!.pagination
				if (payload.success) {
					state.proxy_usage = payload.data!.records
				} else {
					state.proxy_usage = []
				}
			})
			.addCase(fetchProxyUsage.rejected, (state, action) => {
				state.loading = false
				state.error = action.error.message || 'Something went wrong'
			})
	},
})

export default accountSlice.reducer
